import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs/Observable';

import { LicenseService } from '../../services/license.service';
import { NotificationService } from '../../services/notification.service';
import { LoadingPage } from '../../../shared/components/loading/loading.page.component';
import { ProfileService } from '../profile/profile.service';
import { ModalSize, SmartModalService } from '../../services/smart-modal.service';
import { PrivacyPolicyModalComponent } from '../../../shared/components/modal/privacy-policy-modal.component';
import { Subject } from 'rxjs/Subject';
import { AuthService } from '../../services/auth.service';

declare var moment: any;

@Component({
    selector: 'itpx-courses',
    templateUrl: './courses.component.html',
    styleUrls: ['./courses.component.css']
})
export class CoursesComponent extends LoadingPage implements OnInit {

    private tiles: Array<any>;
    private openModal = new Subject<any>();
    private classMapping: { id: string; assignment: Observable<any>; }[];
    private licenses$: Observable<any>;

    constructor(
        private licenseService: LicenseService,
        private profileService: ProfileService,
        private notificationService: NotificationService,
        private modalService: SmartModalService,
        private authService: AuthService
    ) {
        super();
    }


    ngOnInit() {
        this.licenses$ = this.licenseService.getLicenses().share();

        this.licenses$.bindToLifecycle(this)
            .map(body => body.data)
            .subscribe(
                data => {
                    this.buildTiles(data);
                    this.classMapping = this.tiles.filter(assignment => 'class' === assignment.item.type)
                        .map(classType => ({ id: classType.item.id, assignment: this.loadClassAssignments(classType.item.id) }))
                },
                err => this.handleError(err)
            );

        this.openModal
            .subscribe(data => {
                this.modalService.open(PrivacyPolicyModalComponent, { text: data.content, lastUpdate: data.updatedAt }, 'Privacy Policy', ModalSize.Lg)
                    .bindToLifecycle(this)
                    .map(r => r.result)
                    .subscribe(
                        v => {
                            if (v)
                                this.profileService.updateConsent(data.updatedAt).neverError().subscribe();
                            else
                                this.authService.logout();
                        },
                        err => {
                            this.authService.logout();
                        }
                    );
            })

        Observable.zip(this.profileService.getProfile(), this.profileService.loadPrivacyPolicy())
            .subscribe(([profileData, hamletData]) => {
                let consentDate = profileData.data.consentDate ? moment(profileData.data.consentDate).utc() : null;
                let lastUpdate = moment(hamletData.data.updatedAt).utc();

                if (consentDate == null || lastUpdate.isAfter(consentDate)) {
                    this.openModal.next(hamletData.data);
                }
            });
    }

    private buildTiles(data: Array<any>) {
        let tiles: any[] = data.map(t => {
            let isExam = t.productVariant && t.productVariant.product && t.productVariant.product.type == 'Exam';
            let target = null;
            /*t.type = 'certificate';*/
            if (isExam) target = '';
            else if (t.type == 'assignment') target = ['/app/course/', t.id];
            else target = ['/app/class/', t.id];

            let tile = {
                isExam: isExam,
                isCertificate: t.type == 'certificate',
                item: t,
                title: t.name,
                target: target,
                description: t.information,
                icon: 'fa-book',
                color: 'grey',
                isClass: t.type == 'class',
                imageUrl: null,
                completionPercentage: t.completionPercentage,
                type: t.productVariant && t.productVariant.product ? t.productVariant.product.type : null,
            };

            if (!tile.isClass) {
                tile.imageUrl = t.productVariant.product.imageUrl;
            }

            return tile;
        });

        this.tiles = tiles;
        this.ready();
    }

    private handleError(error: any) {
        this.notificationService.error(error, 'Failed');
        this.ready();
    }

    private loadClassAssignments(classId: string) {
        return this.licenseService.getClassAssignments(classId)
            .neverError()
            .map(body => body.data)
            .cacheResult();
    }

    getDetails(id: string) {
      if(this.classMapping && this.classMapping.length > 0){
        let obj = this.classMapping.find(itr => itr.id === id);
        if(obj && obj.hasOwnProperty('assignment'))
          return obj.assignment;
      }
      return Observable.empty();
    }
}



// WEBPACK FOOTER //
// ./src/app/core/components/course/courses.component.ts